var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/file-types","title":"Lista typów plików","numeral_text":['typ pliku', 'typy plików', 'typów plików'],"columns_title":['name', 'icon', 'ext']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }